import { InjectionToken } from '@angular/core';

type Social = {
  url: string;
  icon: string;
  title: string;
};

type Socials = Social[];

export interface BackgroundSizes {
  screen: string;
  thumbnail: string;
};

export interface Environment {
  // base: string;
  url: string;
  title: string;
  slogan: string;
  defaultImage: string;
  iconSet: string;
  socials: Socials;
}

export const ENVIRONMENT = new InjectionToken<Environment>(
  'ENVIRONMENT'
);

export const ANIMATIONS = new InjectionToken<{
  duration: string;
}>(
  'ANIMATIONS'
);

export interface ImageStyles {
  replace_pattern: string;
  backround_sizes: BackgroundSizes;
  backround_sizes_img: string[];
  background_sizes_webp: string[];
  background_default: string;
}

export const IMAGE_STYLES = new InjectionToken<ImageStyles>(
  'IMAGE_STYLES'
);

